import React, { useMemo } from 'react';
import { Polyline } from 'react-leaflet';
import { calculateActivityLines } from '../../utils/activityLineUtils';

const ActivityConnectionLines = ({ mapData, display, user }) => {
  const { showOnlyFirstVisits } = user.mapSettings;

  const activityLines = useMemo(() => {
    if (display.selectedTour === undefined || display.highlightStop === undefined) {
      return [];
    }
    if (display.highlightStop === -1) {
      return [];
    }

    return calculateActivityLines(
      mapData,
      display.selectedTour,
      display.highlightStop,
      showOnlyFirstVisits,
    );
  }, [mapData, display.selectedTour, display.highlightStop, showOnlyFirstVisits]);

  if (!activityLines.length) return null;

  return (
    <>
      {activityLines.map((line) => (
        <Polyline
          key={line.key}
          positions={line.positions}
          pathOptions={{
            color: line.color,
            weight: 3,
            opacity: 0.8,
            dashArray: '5, 10',
          }}
        />
      ))}
    </>
  );
};

export default ActivityConnectionLines;
